import { hexToBn } from '@polkadot/util';

import * as Cord from '@cord.network/sdk';
import { Buffer } from "buffer";


export function calculateVCHash(
    vc,
    contentHashes,
){
    const { issuanceDate, validFrom, validUntil, issuer, credentialSubject } =
        vc;

    let newCredContent= {
        issuanceDate,
        validFrom,
        validUntil,
        issuer,
        credentialSubject,
    };
    if (contentHashes) {
        newCredContent = {
            issuanceDate,
            validFrom,
            validUntil,
            issuer,
            holder: credentialSubject.id,
            contentHashes,
        };
    }
    const serializedCred = Cord.Utils.Crypto.encodeObjectAsStr(newCredContent);
    const credHash = Cord.Utils.Crypto.hashStr(serializedCred);
    return credHash;
}

export function makeStatementsJsonLD(
    contents,
    schemaId,
){
    const normalized = jsonLDcontents(contents, schemaId);
    return Object.entries(normalized).map(([key, value]) =>
        JSON.stringify({ [key]: value }),
    );
}

function jsonLDcontents(
    contents,
    schemaId,
){
    const result=  {};

    const flattenedContents = Cord.Utils.DataUtils.flattenObject(
        contents || {},
    );
    const vocabulary = `${schemaId}#`;
    result['@context'] = { '@vocab': vocabulary };

    Object.entries(flattenedContents).forEach(([key, value]) => {
        result[vocabulary + key] = value;
    });

    return result;
}

export async function getFileHash(file) {
    const arrayBuffer = await file.arrayBuffer();
    const bifferadat = Buffer.from(new Uint8Array(arrayBuffer));
    const hashHex = await Cord.Utils.Crypto.hashStr(bifferadat);
    return hashHex;
  }

export function normalization(inputString){
    const cleanString = inputString.replace(/[_-]/g, ' ');
    const stringList = cleanString.split(" ");
    const normalizedList = stringList.map((key)=> {
            return key.charAt(0).toUpperCase() + key.slice(1);
        });
    return normalizedList.toString().replace(/,/g," ");
}